

import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FilterEmployeeData = ({ setUserDetailResponse, setRecordCount, filterCityData, setFilterCityData }) => {
  const [regionResponse, setRegionResponse] = useState([]);
  const [departmentResponse, setDepartmentResponse] = useState([]);
  const [locationsResponse, setLocationsResponse] = useState([]);
  const [recordCountfilter, setRecordCountfilter] = useState(0);

  const [formData, setFormData] = useState({
    status: '',
    Meal_Preference: '',
    region: '',
    department: '',
    desg_id: '',
    dept_id: '',
    region_id: 0,
    location: ''
  });

  const baseAPI = process.env.REACT_APP_API_URL;

  const getRegions = async () => {
    const storedToken = JSON.parse(localStorage.getItem('token'));
    if (storedToken) {
      try {
        const response = await axios.get(`${baseAPI}adminget/GETRegion?region_id=0`, {
          headers: { Authorization: `Bearer ${storedToken}` },
        });
        setRegionResponse(response.data.data);

      } catch (error) {
        console.error('Error fetching region data:', error);
      }
    }
  };

  const getDepartments = async () => {
    const storedToken = JSON.parse(localStorage.getItem('token'));
    if (storedToken) {
      try {
        const response = await axios.get(`${baseAPI}adminget/GETDepartment?department=0`, {
          headers: { Authorization: `Bearer ${storedToken}` },
        });
        setDepartmentResponse(response.data.data);
      } catch (error) {
        console.error('Error fetching department data:', error);
      }
    }
  };

  function setLocation() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetEmpLocation`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {          
          setLocationsResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  useEffect(() => {
    getRegions();
    getDepartments();
    setLocation();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === 'region' && { region_id: parseInt(value) }),
      ...(name === 'department' && { dept_id: parseInt(value) }),
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem('token'));

    if (storedToken) {
      try {
        const url = `${baseAPI}adminget/GETEmployee?employeeID=&desg_id=${parseInt(formData.desg_id) || 0}&dept_id=${parseInt(formData.dept_id) || 0}&region_id=${parseInt(formData.region_id) || 0}&meal_Preference=${formData.Meal_Preference || ''}&status=${formData.status || ''}&location=${formData.location || ''}`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${storedToken}` },
        });

        // console.log("lengthempl",response.data.data.length)

        setUserDetailResponse(response.data.data);
        setRecordCount(response.data.data.length);
        // setFilterCityData(false)



      } catch (error) {
        console.error('Error fetching filtered employee data:', error);
      }
    }
  };




  return (
    <div className="container-fluid">
      <div className="cityDetail">
        <div className="city-form">
          <table>
            <thead>
              {/* <tr>
                <th style={{textAlign:"center"}}>Region</th>
                <th style={{textAlign:"center"}}>Department</th>
                <th style={{textAlign:"center"}}>Meal Preference</th>
                <th style={{textAlign:"center"}}>Status</th>
              </tr> */}
            </thead>
            <tbody>
              <tr>
                <td>
                  <select
                    className="form-control"
                    name="region"
                    value={formData.region}
                    onChange={handleChange}
                    placeholder='Region'
                  >
                    <option value="">Select Region</option>
                    {regionResponse.map((region) => (
                      <option key={region.region_id} value={region.region_id}>
                        {region.region_name}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="form-control"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder='location'
                  >
                    <option value="">Select Location</option>
                    {locationsResponse.map((loc) => (
                      <option key={loc} value={loc}>
                        {loc}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="form-control"
                    name="department"
                    value={formData.department}
                    onChange={handleChange}
                    placeholder='Department'
                  >
                    <option value="">Select Department</option>
                    {departmentResponse.map((department) => (
                      <option key={department.dept_id} value={department.dept_id}>
                        {department.department}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="form-control"
                    name="Meal_Preference"
                    value={formData.Meal_Preference}
                    onChange={handleChange}
                    placeholder='Meal Preference'
                  >
                    <option value="">Select Meal Preference</option>
                    <option value="Veg">Veg</option>
                    <option value="Non-Veg">Non-Veg</option>
                  </select>
                </td>
                <td>
                  <select
                    className="form-control"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="">Select Status</option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterEmployeeData;

